<template>
  <!-- 预充值电表-电表管理 -->
  <basic-container>
    <avue-crud
      ref="crud"
      :option="tableOption"
      :table-loading="loading"
      :data="tableData"
      :page.sync="tablePage"
      :search.sync="searchForm"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="loadData"
      @on-load="loadData"
    >
      <template slot="menuLeft">
        <el-button
          v-if="permissionList.addBtn"
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="openDialog('add')"
        >
          新增
        </el-button>
        <el-button
          v-if="permissionList.exportBtn"
          type="success"
          plain
          size="small"
          icon="el-icon-download"
          @click="exportData"
        >
          导出
        </el-button>
      </template>
      <template slot-scope="{ row }" slot="menu">
        <el-button
          v-if="permissionList.editBtn"
          type="text"
          size="small"
          @click="openDialog('edit', row)"
        >
          电表校正
        </el-button>
        <el-button
          v-if="permissionList.logBtn"
          type="text"
          size="small"
          @click="openDialog('log', row)"
        >
          校正日志
        </el-button>
        <el-button
          v-if="permissionList.rechargeBtn"
          type="text"
          size="small"
          @click="openDialog('recharge', row)"
        >
          充值
        </el-button>
        <el-button
          v-if="permissionList.withholdBtn"
          type="text"
          size="small"
          @click="openDialog('withhold', row)"
        >
          扣缴
        </el-button>
      </template>
      <template slot="propertyIdSearch">
        <LazyTree
          placeholder="关联房产"
          @load="getPropertyTreeData"
          @setDefaultFinished="loadData"
          :needDefaultItem="true"
          :needDelIcon="false"
          :selectedId.sync="currPropertyId"
          :treeProps="{
            label: 'objectFullName',
            value: 'id',
          }"
        ></LazyTree>
      </template>
      <template slot="propertyId" slot-scope="{ row }">
        <span>{{ row.propertyName }}</span>
      </template>
      <template slot="isAlarmSearch" slot-scope="{ row }">
        <span v-if="row.isAlarm == '是'" style="color: red;">{{ row.isAlarm }}</span>
        <span v-else>{{ row.isAlarm }}</span>
      </template>
    </avue-crud>
    <!-- 弹框 -->
    <el-dialog
      v-if="isDialogShow"
      width="60%"
      :title="dialogTitle"
      :visible.sync="isDialogShow"
      :before-close="beforeCloseDialog"
      :append-to-body="true"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
    >
      <Form
        v-if="dialogType == 'add' || dialogType == 'edit'"
        :dialogType="dialogType"
        :rowData="rowData"
        @update="updateTableDataSuccess"
        @close="beforeCloseDialog"
      ></Form>
      <LogList v-if="dialogType == 'log'" :rowData="rowData" @close="closeDialog"></LogList>
      <Recharge
        v-if="dialogType == 'recharge'"
        :rowData="rowData"
        @update="updateTableDataSuccess"
        @close="beforeCloseDialog"
      ></Recharge>
      <Withhold
        v-if="dialogType == 'withhold'"
        :rowData="rowData"
        @update="updateTableDataSuccess"
        @close="beforeCloseDialog"
      ></Withhold>
    </el-dialog>
  </basic-container>
</template>

<script>
import { mapGetters } from 'vuex';
import qs from 'qs';
import LazyTree from '@/views/components/lazy-tree';
import Form from './form';
import LogList from './log-list';
import Withhold from './withhold';
import Recharge from './recharge';
import { getToken } from '@/util/auth';
import { getPageListApi } from '@/api/electric-meter/electric-meter-management';
import { getTreeChildrenPowerNode } from '@/api/v4ward/property/baseproperty';

export default {
  components: {
    LazyTree,
    Form,
    LogList,
    Withhold,
    Recharge,
  },
  data() {
    return {
      dialogType: '', // 弹框的类型
      dialogTitle: '', // 弹框显示的标题
      isDialogShow: false, // 弹框是否显示着
      needCloseConfirm: false, // 关闭弹框时是否需要确认弹框，该值是根据场景动态调整的
      rowData: [], // 选中行对应的数据
      searchForm: {}, // 搜索条件
      currPropertyId: '', // 房产id
      loading: false, // 是否正在加载表格数据
      tableData: [], // 表格数据
      // 数据的分页信息
      tablePage: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      // 表格显示的配置项
      tableOption: {
        height: 'auto',
        calcHeight: 'auto',
        border: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        dialogClickModal: false,
        searchMenuSpan: 6,
        searchLabelWidth: 100,
        labelWidth: 100,
        menuWidth: 220,
        column: [
          {
            label: '电表表号',
            prop: 'code',
            search: true,
            maxlength: 30,
            showWordLimit: true,
          },
          {
            label: '余额（元）',
            prop: 'balance',
            align: 'right',
          },
          {
            label: '余额预警',
            prop: 'isAlarmSearch',
            slot: true,
            search: true,
            type: 'select',
            props: { label: 'dictValue', value: 'dictKey' },
            dicData: [
              {
                dictValue: '是',
                dictKey: 1,
              },
              {
                dictValue: '否',
                dictKey: 0,
              },
            ],
          },
          {
            label: '关联房产',
            prop: 'propertyId',
            slot: true,
            search: true,
            searchslot: true,
            searchOrder: 2,
          },
          {
            label: '单价（度/元）',
            prop: 'unitPrice',
            align: 'right',
          },
          {
            label: '上期止码',
            prop: 'lastEndNum',
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.electricMeterManagement_add, false),
        exportBtn: this.vaildData(this.permission.electricMeterManagement_export, false),
        editBtn: this.vaildData(this.permission.electricMeterManagement_edit, false),
        logBtn: this.vaildData(this.permission.electricMeterManagement_log, false),
        rechargeBtn: this.vaildData(this.permission.electricMeterManagement_recharge, false),
        withholdBtn: this.vaildData(this.permission.electricMeterManagement_withhold, false),
      };
    },
  },
  watch: {
    currPropertyId() {
      this.searchForm.propertyId = this.currPropertyId;
    },
  },
  mounted() {
    this.ajustView();
  },
  activated() {
    // 当从其它窗口切换回当前页面时，表格线会错乱，加上如下处理可解决此问题
    this.$nextTick(() => {
      this.$refs.crud.refreshTable();
    });
  },
  methods: {
    /* 调整视图区域 */
    ajustView() {
      const tableInitH = this.bodyHeight - 335; // 表格区域初始化高度
      const searchH = 56; // 搜索区域占的高度
      this.tableOption.height = tableInitH;

      this.$nextTick(() => {
        setTimeout(() => {
          let children = this.$refs.crud.$children[1].$children;
          children[children.length - 2].$el.addEventListener('click', () => {
            if (this.tableOption.height == tableInitH) {
              this.tableOption.height = tableInitH + searchH;
            } else {
              this.tableOption.height = tableInitH;
            }
            this.$refs.crud.getTableHeight();
          });
        });
      });

      // 当窗口尺寸发生变化时，表格线会错乱，加上如下处理可解决此问题
      setTimeout(() => {
        window.onresize = () => {
          this.$nextTick(() => {
            this.$refs.crud.refreshTable();
          });
        };
      });
    },
    /* 加载表格数据 */
    loadData(page) {
      // watch有异步延时，这里如果检测到值没有及时同步，则手动同步一下
      if (this.currPropertyId && !this.searchForm.propertyId) {
        this.searchForm.propertyId = this.currPropertyId;
      }
      if (!this.searchForm.propertyId) return;
      page = page || this.tablePage;
      this.loading = true;
      getPageListApi(
        Object.assign({ current: page.currentPage, size: page.pageSize }, this.searchForm)
      ).then(({ data }) => {
        this.tablePage.total = data.total;
        this.tableData = data.records;
        this.loading = false;
      });
    },
    /* 重置搜索 */
    searchReset() {
      this.searchForm = {
        propertyId: this.currPropertyId,
      };
      this.tablePage.currentPage = 1;
      this.loadData();
    },
    /* 条件搜索 */
    searchChange(params, done) {
      this.searchForm = params;
      this.tablePage.currentPage = 1;
      this.loadData();
      done();
    },
    /* 表格数据更新成功 */
    updateTableDataSuccess() {
      this.loadData();
      this.dialogType = '';
      this.isDialogShow = false;
    },
    /* 打开弹框 */
    openDialog(type, rowData = {}) {
      let titles = {
        add: '新增',
        edit: '电表校正',
        log: '校正日志',
        recharge: '电表充值',
        withhold: '电表扣缴',
      };
      this.dialogTitle = titles[type];
      this.dialogType = type;
      this.rowData = rowData;
      this.needCloseConfirm = true;
      this.isDialogShow = true;
    },
    /* 关闭表单弹框的确认框 */
    beforeCloseDialog(done) {
      if (!this.needCloseConfirm) {
        if (typeof done == 'function') {
          done();
        } else {
          this.dialogType = '';
          this.isDialogShow = false;
        }
      } else {
        this.$confirm(' 是否关闭继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            if (typeof done == 'function') {
              done();
            } else {
              this.dialogType = '';
              this.isDialogShow = false;
            }
          })
          .catch(() => {});
      }
    },
    /* 直接关闭弹框 */
    closeDialog() {
      this.dialogType = '';
      this.isDialogShow = false;
    },
    /* 导出 */
    exportData() {
      let params = qs.stringify(this.searchForm);
      window.open(
        `/api/v4ward/prePay/electricity/meter/exportPrepayMeter?${
          this.website.tokenHeader
        }=${getToken()}&${params}`
      );
    },
    /* 加载房产树的数据 */
    getPropertyTreeData(node, resolve) {
      getTreeChildrenPowerNode({
        id: node.level == 0 ? 0 : node.data.id,
        power: 1,
      }).then(({ data }) => {
        resolve(data);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/* 搜索按钮靠右对齐 */
::v-deep .avue-form__menu--center {
  text-align: right !important;
}

/* 表单的每一项宽度最大化 */
::v-deep .el-form-item {
  width: 100%;
}
</style>
